export function replaceBrokenImage(event) {
    event.currentTarget.onerror = null
    event.currentTarget.src = "/assets/placeholder.svg"
}
